import Row from '../ResponsiveRow/row';
import React, { JSX } from 'react';
import Styles from './ProgressionBar.module.scss';

type StepItem = {
  Title: string;
  subTitle?: string;
};

type ProgressionBarProps = {
  step: number | string;
  steps: StepItem[];
};

const ProgressionBar = ({ step = 1, steps }: ProgressionBarProps): JSX.Element => {
  const currentStep = typeof step === 'string' ? parseInt(step) : step;

  return (
    <Row>
      <div className={Styles.steps}>
        <div className={Styles.numbers}>
          {steps?.map((stepContent, index) => (
            <div key={index} className={`d-flex ${Styles.step}`}>
              <div
                className={`${Styles.stepCount} ${currentStep == index + 1 ? Styles.active : ''} ${
                  currentStep > index + 1 ? Styles.finished : ''
                }`}
              >
                {index + 1}
              </div>
              <span>{stepContent?.Title}</span>
              {stepContent?.subTitle && (
                <div className={Styles.optional}>{stepContent.subTitle}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Row>
  );
};

export default ProgressionBar;
